import { NEXT_PUBLIC_DEEP_LINK_URL } from '@env';
import useMedia from '@hooks/use-media';
import { useFeatureFlag } from '@modules/feature-flag';
import { parseAndCachePrefilledCardData, parseAndCacheReferralTrackingData } from '@modules/referral-helpers';
import type { NextPage } from 'next';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

const SignupRedirect: NextPage = () => {
  const { query, replace, isReady } = useRouter();
  const hasRedirected = useRef(false);

  const [variant, { loading: experimentLoading, expose }] = useFeatureFlag(
    'mobile-signup-direct-link',
    'control',
    false,
  );

  const screenSizeCategory = useMedia<'small' | 'large'>([`(min-width: ${701}px)`], ['large'], 'small');

  useEffect(() => {
    if (!isReady || experimentLoading || hasRedirected.current) {
      return;
    }

    const queryParams = new URLSearchParams(query as Record<string, string>).toString();

    if (query._dl === 'shareCard') {
      parseAndCachePrefilledCardData(query);
      parseAndCacheReferralTrackingData(query);
    }

    if (screenSizeCategory === 'large') {
      replace(`/onboarding/customize-card?${queryParams}`);
      hasRedirected.current = true;
      return;
    }

    if (screenSizeCategory === 'small') {
      expose();

      if (variant === 'treatment') {
        const deepLinkUrl = new URL(NEXT_PUBLIC_DEEP_LINK_URL);
        deepLinkUrl.searchParams.set('v', 'croexp131025');

        // Mobile signup direct link, attempts app store before falling back to web
        window.location.href = deepLinkUrl.toString();
      } else {
        replace(`/onboarding/personal-details?${queryParams}`);
      }

      hasRedirected.current = true;
      return;
    }
  }, [query, isReady, experimentLoading, variant, screenSizeCategory, replace, expose]);

  return null;
};

export default SignupRedirect;
